const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const API_ROUTES = {
  // Auth
  AUTH: {
    SIGNUP: `${API_BASE}/api/auth/signup`,
    LOGIN: `${API_BASE}/api/auth/login`,
    LOGOUT: `${API_BASE}/api/auth/logout`,
    REFRESH: `${API_BASE}/api/auth/refresh`,
    GOOGLE: `${API_BASE}/api/auth/google`
  },

  // Users
  USERS: {
    ME: `${API_BASE}/api/users/me`,
    USAGE: `${API_BASE}/api/users/usage`,
    ONBOARDING: `${API_BASE}/api/users/onboarding`
  },

  // Transcriptions
  TRANSCRIPTIONS: {
    BASE: `${API_BASE}/api/transcriptions`,
    PRESIGNED: `${API_BASE}/api/transcriptions/presigned`,
    SUBMIT: `${API_BASE}/api/transcriptions/submit`,
    GET: (id) => `${API_BASE}/api/transcriptions/${id}`,
    STREAM: (id) => `${API_BASE}/api/transcriptions/${id}/stream`,
    DELETE: (id) => `${API_BASE}/api/transcriptions/${id}`,
    TRANSLATE: (id) => `${API_BASE}/api/transcriptions/${id}/translate`
  },

  // Editor
  EDITOR: {
    GET: (id) => `${API_BASE}/api/editor/${id}`,
    SAVE: (id) => `${API_BASE}/api/editor/${id}`,
    SETTINGS: (id) => `${API_BASE}/api/editor/${id}/settings`,
    EXPORT: (id) => `${API_BASE}/api/editor/${id}/export`,
    AUDIO: (id) => `${API_BASE}/api/editor/${id}/audio`
  },

  // Dashboard
  DASHBOARD: {
    JOBS: `${API_BASE}/api/dashboard/jobs`,
    PENDING: `${API_BASE}/api/dashboard/pending`,
    STATS: `${API_BASE}/api/dashboard/stats`
  },

  // Subscriptions
  SUBSCRIPTIONS: {
    WELCOME_OFFER: `${API_BASE}/api/subscriptions/welcome-offer`,
    PLANS: `${API_BASE}/api/subscriptions/plans`,
    ME: `${API_BASE}/api/subscriptions/me`,
    CHECKOUT: `${API_BASE}/api/subscriptions/checkout`,
    CREATE_DIRECT: `${API_BASE}/api/subscriptions/create-direct`,
    PORTAL: `${API_BASE}/api/subscriptions/portal`
  },

  // Settings
  SETTINGS: {
    PROFILE: `${API_BASE}/api/settings/profile`,
    BILLING: `${API_BASE}/api/settings/billing`,
    PAYMENT_METHODS: `${API_BASE}/api/settings/payment-methods`,
    PAYMENT_METHODS_SETUP: `${API_BASE}/api/settings/payment-methods/setup`,
    PAYMENT_METHOD: (id) => `${API_BASE}/api/settings/payment-methods/${id}`,
    PAYMENT_METHOD_DEFAULT: (id) => `${API_BASE}/api/settings/payment-methods/${id}/default`,
  },

  // Verification
  VERIFICATION: {
    SEND_OTP: `${API_BASE}/api/verification/send-otp`,
    VERIFY_OTP: `${API_BASE}/api/verification/verify-otp`,
    STATUS: `${API_BASE}/api/verification/status`
  }
};
